package com.wintermar.inspection.feature.data.repository

import com.apollographql.apollo.ApolloClient
import com.apollographql.apollo.api.Optional
import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.core.domain.handleAsFlow
import com.wintermar.inspection.feature.data.remote.mapper.auth.toLoginModel
import com.wintermar.inspection.feature.data.remote.request.HeaderRequest
import com.wintermar.inspection.feature.domain.model.auth.LoginModel
import com.wintermar.inspection.feature.domain.repository.AuthRepository
import com.wintermar.inspection.graphql.LoginMutation
import kotlinx.coroutines.flow.Flow

class AuthRepositoryImpl(
    private val apolloClient: ApolloClient
) : AuthRepository {
    override fun login(email: String, password: String): Flow<FlowResult<LoginModel>> {
        return handleAsFlow(
            request = {
                apolloClient
                    .mutation(
                        LoginMutation(
                            email = Optional.presentIfNotNull(email),
                            password = password
                        )
                    )
                    .addHttpHeader(HeaderRequest.OPERATION, LoginMutation.OPERATION_NAME)
                    .execute()
            }
        ) { response ->
            response.data?.login?.toLoginModel() ?: LoginModel()
        }
    }
}
